import { css } from 'linaria';
import fonts from 'style/fonts';
export const logo = "l1ujgkbl";
export const word = "wrsj8do";
export const link = "lhr07j6";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/logo/styles.linaria.css");